// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2R07x","sendOtp":"AuthorizeToLogin_sendOtp__2Sh5q"};